/*
 * EMI page (sections/ps-emi-*.liquid): tenure switching.
 *
 * A scope element [data-emi-scope] holds one chip group [data-emi-tenures]
 * of buttons [data-emi-t="3|6|9|12"]. Picking a chip:
 *   - sets data-t and the --t custom property on the scope,
 *   - swaps every [data-emi-v] inside it to its data-v<months> text
 *     (amounts are computed in Liquid, so prices stay in one place),
 *   - marks [data-emi-seg] tiles past the tenure with .is-off.
 * Reveal-on-scroll comes from assets/ps-pat.js. Clicks are tracked in
 * snippets/webengage-click-tracking.liquid. Only the first copy runs.
 */
(function () {
  if (window.PSEmi) return;
  window.PSEmi = true;

  function setTenure(scope, t, pop) {
    scope.setAttribute('data-t', t);
    scope.style.setProperty('--t', t);
    scope.querySelectorAll('[data-emi-t]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('data-emi-t') === String(t) ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-emi-v]').forEach(function (el) {
      var next = el.getAttribute('data-v' + t);
      if (next == null || el.textContent === next) return;
      el.textContent = next;
      if (pop) {
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      }
    });
    scope.querySelectorAll('[data-emi-seg]').forEach(function (seg) {
      seg.classList.toggle('is-off', parseInt(seg.getAttribute('data-emi-seg'), 10) > t);
    });
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-emi-scope]').forEach(function (scope) {
      if (scope.__emi) return;
      scope.__emi = true;
      setTenure(scope, parseInt(scope.getAttribute('data-t'), 10) || 12, false);
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-emi-t]');
    if (!chip) return;
    var scope = chip.closest('[data-emi-scope]');
    if (!scope) return;
    setTenure(scope, parseInt(chip.getAttribute('data-emi-t'), 10), true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
